import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import { styled } from '@mui/material';
import { isNil } from 'lodash';
import PropTypes from 'prop-types';

import { mediaQuery } from 'constants/ui';
import { useBreakpoints } from 'hooks/useBreakpoints';

import { DEFAULT_ICON_SRC, DEFAULT_LOGO_ALT, DEFAULT_LOGO_SRC } from './LenderLogo.constants';

const Logo = styled('img')({
  width: '200px',
  minWidth: '200px',
  flexShrink: 0,

  [mediaQuery.tablet]: {
    width: '140px',
    minWidth: '140px',
  },

  [mediaQuery.mobile]: {
    width: '140px',
    minWidth: 'auto',
    maxWidth: '140px',
    objectFit: 'contain',
  },
});

const LogoIcon = styled('img')({
  width: '36px',
  minWidth: '36px',
  height: '36px',
  flexShrink: 0,
});

const LenderLogo = ({ isClickable = true, logoUrl = null, alt = null, dataTestId }) => {
  const [hasError, setHasError] = useState(false);

  const { isMobile } = useBreakpoints();

  const onError = useCallback(() => setHasError(true), []);

  const hasCustomLogo = !isNil(logoUrl) && !hasError;
  const isIconShown = isMobile && !hasCustomLogo;

  const src = hasCustomLogo ? logoUrl : DEFAULT_LOGO_SRC;

  const logo = isIconShown ? (
    <LogoIcon alt={alt || DEFAULT_LOGO_ALT} src={DEFAULT_ICON_SRC} />
  ) : (
    <Logo alt={alt || DEFAULT_LOGO_ALT} src={src} onError={onError} />
  );

  return isClickable ? (
    <Link className="flex" data-testid={dataTestId} to="/">
      {logo}
    </Link>
  ) : (
    logo
  );
};

LenderLogo.propTypes = {
  dataTestId: PropTypes.string,
  isClickable: PropTypes.bool,
  logoUrl: PropTypes.string,
  alt: PropTypes.string,
};

export default LenderLogo;
